import React from "react";
import {router, usePage} from "@inertiajs/react";
import {useLaravelReactI18n} from "laravel-react-i18n";
import InertiaTable from "laravel-inertia-react-table";
import {mdiPlus} from "@mdi/js";
import Icon from "@mdi/react";
import {Button} from "react-bootstrap";

export default function MonthlyClosures(props) {
    const { t } = useLaravelReactI18n();
    const { monthlyclosures } = usePage().props;

  const handleAddClick = () => {
    router.get('monthly-closures/create');
  }

  const customToolbarButtons = (<Button variant="secondary" onClick={handleAddClick}><Icon path={mdiPlus} size={1}/></Button>);


  return (<InertiaTable title={t('Monthly Closures')} data={ monthlyclosures } customToolbarButtons={customToolbarButtons}/>);
}



